// extracted by mini-css-extract-plugin
module.exports = {"body":"App_body__ZTvxg","main":"App_main__3ZkGI","navigation":"App_navigation__3pqZF"};